import { contains } from './contains';

// checks if the given element has or contains in the focus
export function hasFocus(elem:HTMLElement) {
  return contains(elem, document.activeElement as HTMLElement);
}
